(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["everyday-akoya-player"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const trackKey = 'bisSpiraBgmTrack';
    const volumeKey = 'bisSpiraBgmVolume';

    const readStorage = (key) => {
      try {
        return window.localStorage.getItem(key);
      } catch (error) {
        return null;
      }
    };

    const writeStorage = (key, value) => {
      try {
        window.localStorage.setItem(key, value);
      } catch (error) {
        return;
      }
    };

    const setupPlayer = (player) => {
      if (player.dataset.initialized === 'true') return;
      player.dataset.initialized = 'true';

      const audio = player.querySelector('[data-bis-bgm-audio]');
      const toggle = player.querySelector('[data-bis-bgm-toggle]');
      const toggleIcon = toggle.querySelector('span');
      const track = player.querySelector('[data-bis-bgm-track]');
      const volume = player.querySelector('[data-bis-bgm-volume]');
      const savedTrack = readStorage(trackKey);
      const initialVolume = Number.parseFloat(player.dataset.initialVolume || '0.22');
      const savedVolume = Number.parseFloat(readStorage(volumeKey));

      if (savedTrack && Array.from(track.options).some((option) => option.value === savedTrack)) {
        track.value = savedTrack;
      }

      audio.src = track.selectedOptions[0].dataset.src;
      audio.volume = Number.isFinite(savedVolume) ? Math.min(1, Math.max(0, savedVolume)) : initialVolume;
      volume.value = audio.volume;

      const updateToggle = () => {
        const isPlaying = !audio.paused;
        toggle.classList.toggle('is-playing', isPlaying);
        toggle.setAttribute('aria-label', isPlaying ? player.dataset.pauseLabel : player.dataset.playLabel);
        toggleIcon.textContent = isPlaying ? 'Ⅱ' : '▶';
      };

      toggle.addEventListener('click', async () => {
        if (!audio.paused) {
          audio.pause();
          return;
        }

        document.querySelectorAll('[data-bis-bgm-audio]').forEach((otherAudio) => {
          if (otherAudio !== audio) otherAudio.pause();
        });

        try {
          await audio.play();
        } catch (error) {
          console.error('Bis・SPIRA BGM playback failed.', error);
          updateToggle();
        }
      });

      track.addEventListener('change', () => {
        audio.pause();
        audio.src = track.selectedOptions[0].dataset.src;
        audio.load();
        writeStorage(trackKey, track.value);
        updateToggle();
      });

      volume.addEventListener('input', () => {
        audio.volume = Number.parseFloat(volume.value);
        writeStorage(volumeKey, String(audio.volume));
      });

      audio.addEventListener('play', updateToggle);
      audio.addEventListener('pause', updateToggle);
      audio.addEventListener('ended', updateToggle);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) audio.pause();
      });
      updateToggle();
    };

    const setupAllPlayers = (scope = document) => {
      scope.querySelectorAll('[data-bis-bgm-player]').forEach(setupPlayer);
    };

    setupAllPlayers();
    document.addEventListener('shopify:section:load', (event) => setupAllPlayers(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
